import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import * as Sentry from '@sentry/vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import { faArrowLeft, faBars, faCow, faCreditCard, faEnvelope, faHome, faIceCream, faLeaf, faPersonCircleCheck, faQrcode, faRightFromBracket, faUtensils, faXmark, faPiggyBank, faFishFins, faDrumstickBite, faLock, faFileExport, faPen, faSave, faUser, faCheck, faCopy, faTimesCircle, faRedo, faWifi, faList, faCheckCircle, faAddressBook, faPlus, faBell, faInfoCircle, faSpinner, faSort, faSortUp, faSortDown, faTimes, faUsers, faBullhorn, faUserGear, faKey, faFileImport, faScrewdriverWrench, faChevronDown, faChevronUp, faCompass, faBolt, faCalendar, faClock, faHistory, faEdit, faFile, faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faBars, faArrowLeft, faRightFromBracket, faCreditCard, faEnvelope, faLeaf, faQrcode, faPersonCircleCheck, faUtensils, faIceCream, faXmark, faCow, faLock, faPiggyBank, faFishFins, faLeaf, faDrumstickBite, faFileExport, faPen, faSave, faUser, faCheck, faCopy, faTimesCircle, faRedo, faWifi, faList, faCheckCircle, faAddressBook, faPlus, faBell, faInfoCircle, faSpinner, faSort, faSortUp, faSortDown, faTimes, faUsers, faBullhorn, faUserGear, faKey, faFileImport, faScrewdriverWrench, faChevronDown, faChevronUp, faCompass, faBolt, faCalendar, faClock, faHistory, faEdit, faFile, faDownload, faTrash)

let app = createApp(App)

if (process.env.NODE_ENV === 'production') {

  Sentry.init({
    app,
    dsn: "https://0174fff75b231864378887def69e0ae1@o4509549361954816.ingest.de.sentry.io/4509554504237136",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    release: `intern@${process.env.VUE_APP_VERSION}`,
    // Tracing
    tracesSampleRate: process.env.NODE_ENV === 'development' ? 0 : 1.0, // No traces in dev
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  });

}
app.config.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

app.component("font-awesome-icon", FontAwesomeIcon).use(router).use(ToastPlugin).mount("#app");// main.js
